import { SxProps, Theme } from "@mui/material";

export const heroSection: SxProps<Theme> = {
  minHeight: "100vh",
  position: "relative",
  overflow: "hidden",
  backgroundImage: "url('/img/assets/Solar-Install.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const heroOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(4,9,34,0.12)",
  pointerEvents: "none",
};

export const heroRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(ellipse 75% 70% at 50% 50%, rgba(4,9,34,0.72) 0%, rgba(4,9,34,0.32) 55%, transparent 80%)",
  pointerEvents: "none",
};

export const contentWrapper: SxProps<Theme> = {
  textAlign: "center",
};

export const eyebrow: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontSize: "0.85rem",
  fontWeight: 700,
  letterSpacing: "0.2em",
  mb: 2,
  textTransform: "uppercase",
};

export const heroTitle: SxProps<Theme> = {
  fontSize: { xs: "2.2rem", md: "3.2rem" },
  fontWeight: 800,
  fontFamily: "Poppins, sans-serif",
  color: "white",
  lineHeight: 1.15,
  mb: 3,
};

export const gradientSpan: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

export const subtitle: SxProps<Theme> = {
  fontSize: "1.1rem",
  color: "rgba(255,255,255,0.82)",
  mb: 5,
};

export const ctaButton: SxProps<Theme> = {
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  borderRadius: "9999px",
  color: "white",
  fontWeight: 700,
  fontSize: "1rem",
  px: 5,
  py: 1.5,
  textTransform: "none",
  border: "none",
  "&:hover": {
    background: "linear-gradient(90deg, #ea6c0a, #f97316)",
    boxShadow: "0 0 24px rgba(249,115,22,0.4)",
    color: "white",
  },
};
